import React from "react";
import ReportManagementDetailTableHeader from "./components/ReportManagementDetailTableHeader";
import ReportManagementDetailTableRow from "./components/ReportManagementDetailTableRow";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { useClientReportsList } from "../../hooks/ClientReportContext";

const ReportManagementDetailed = () => {
    const {
        clear: refreshTable,
        data,
        error,
        isNextPageLoading,
        isNewRecords,
        isRowLoaded,
        loadMore,
        newRecordsSinceCache,
        sort,
        sortTable,
        totalCount
    } = useClientReportsList();

    return (
        <VirtualTable
            enableScrollTracking={true}
            row={ReportManagementDetailTableRow}
            header={(
                <thead>
                    <tr>
                        <ReportManagementDetailTableHeader property="adviserName" sort={sort} sortTable={sortTable}>Adviser</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="reportName" sort={sort} sortTable={sortTable}>Report</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="masterAccountName" sort={sort} sortTable={sortTable}>Client</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="createdDate" sort={sort} sortTable={sortTable}>Created</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="statusDescription" sort={sort} sortTable={sortTable}>Status</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="authorName" sort={sort} sortTable={sortTable}>Author</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="deadlineDate" sort={sort} sortTable={sortTable}>Deadline</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="rejectCount" sort={sort} sortTable={sortTable} className="text-center">Quality</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="compliantDate" sort={sort} sortTable={sortTable}>Compliant</ReportManagementDetailTableHeader>
                        <ReportManagementDetailTableHeader property="sentDate" sort={sort} sortTable={sortTable}>Sent</ReportManagementDetailTableHeader>
                        <th className="sticky-header">&nbsp;</th>
                    </tr>
                </thead>
            )}
            footer={
                <TableRecordCountDisplayFooter 
                    totalCount={totalCount}
                    isNewRecordsDisplayed={isNewRecords && !isNextPageLoading}
                    newRecordsSinceCache={newRecordsSinceCache}
                    reload={refreshTable}
                />
            }
            error={error}
            isLoading={isNextPageLoading}
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMore}
            itemSize={50}
            itemCount={totalCount === data.length ? totalCount : data.length + 3}
            itemData={data}
        />
    );
};

export default ReportManagementDetailed;